module.exports = __webpack_public_path__ + "static/media/school.30cb28ac.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/icons/school.svg
// module id = 1009
// module chunks = 0